import { FormikProps, getIn } from "formik";
import * as Yup from "yup";

const insuranceIdentifierSchema = (label: string) =>
  Yup.string()
    .trim()
    .nullable()
    .label(label)
    .matches(/^[a-zA-Z0-9]*$/, `${label} must be alphanumeric`)
    .max(50, `${label} cannot exceed 50 characters`);

export const INSURANCE_IDENTIFIER_SHAPE = {
  insuranceId: insuranceIdentifierSchema("Insurance ID"),
  memberId: insuranceIdentifierSchema("Member ID"),
  groupId: insuranceIdentifierSchema("Group ID"),
};

export type InsuranceIdentifierField = keyof typeof INSURANCE_IDENTIFIER_SHAPE;

export const getInsuranceFieldError = <Values>(
  formik: Pick<FormikProps<Values>, "touched" | "errors">,
  index: number,
  field: InsuranceIdentifierField
): string | undefined => {
  const path = `patientInsurances[${index}].${field}`;
  if (!getIn(formik.touched, path)) return undefined;
  const error: unknown = getIn(formik.errors, path);
  return typeof error === "string" ? error : undefined;
};
